import { Navigate, Outlet, RouteObject } from "react-router";
import {
  AhuUnitsIndexRoute,
  AhuUnitsRoute,
} from "@/routes/customers/[customerId]/ahu-units/ahu-units-route";
import { ServiceObjectsRoute } from "@/routes/customers/[customerId]/service-objects/service-objects-route";
import { AhuUnitRoute } from "@/routes/customers/[customerId]/ahu-units/[ahuId]/ahu-unit-route";
import { RelationshipsRoute } from "@/routes/customers/[customerId]/relationships/relationships-route";
import { ServiceObjectRoute } from "@/routes/customers/[customerId]/service-objects/[serviceObjectId]/service-object-route";
import { RelationshipRoute } from "@/routes/customers/[customerId]/relationships/[relationshipId]/relationship-route";
import { commitmentRoutes } from "@/routes/customers/[customerId]/relationships/[relationshipId]/commitments/[commitmentId]/commitment-routes";
import { BusinessCentralContractsRoute } from "@/routes/customers/[customerId]/business-central-contracts/business-central-contracts-route";
import { CustomerAddressRoute } from "@/routes/customers/[customerId]/address/customer-address-route";
import { BuildingsRoute } from "@/routes/customers/[customerId]/buildings/buildings-route";
import { BuildingRoute } from "@/routes/customers/[customerId]/buildings/[buildingId]/building-route";
import { BuildingAddressesRoute } from "@/routes/customers/[customerId]/buildings/addresses/building-addresses-route";
import { BuildingAddressRoute } from "@/routes/customers/[customerId]/buildings/addresses/[addressKey]/building-address-route";
import { CustomerHtzRoute } from "./htz/customer-htz-route";
import { customerHtzRoutes } from "./htz/customer-htz-routes";

export const customerRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="address" replace />,
  },
  {
    path: "address",
    element: <CustomerAddressRoute />,
  },
  {
    path: "ahu-units",
    element: <AhuUnitsRoute />,
    children: [
      {
        index: true,
        element: <AhuUnitsIndexRoute />,
      },
      {
        path: ":ahuId",
        element: <AhuUnitRoute />,
      },
    ],
  },
  {
    path: "business-central-contracts",
    element: <BusinessCentralContractsRoute />,
  },
  {
    path: "buildings",
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <BuildingsRoute />,
      },
      {
        path: "addresses",
        element: <Outlet />,
        children: [
          {
            index: true,
            element: <BuildingAddressesRoute />,
          },
          {
            path: ":addressKey",
            element: <BuildingAddressRoute />,
          },
        ],
      },
      {
        path: ":buildingId",
        element: <BuildingRoute />,
      },
    ],
  },
  {
    path: "htz",
    element: <CustomerHtzRoute />,
    children: customerHtzRoutes,
  },
  {
    path: "service-objects",
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <ServiceObjectsRoute />,
      },
      {
        path: ":serviceObjectId",
        element: <ServiceObjectRoute />,
      },
    ],
  },
  {
    path: "relationships",
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <RelationshipsRoute />,
      },
      {
        path: ":relationshipId",
        element: <RelationshipRoute />,
      },
      {
        path: ":relationshipId/commitments",
        children: commitmentRoutes,
      },
    ],
  },
];
